import { StringContext } from "../../core/StringContext";
import { StringModule } from "../../core/StringModule";
import { StringObject } from "../../objects/StringObject";
import { parsePartOf } from "../../utils/ParsePartOf";

function remap(value: number, from1: number, to1: number, from2: number, to2: number): number {
  return from2 + ((to2 - from2) * (value - from1)) / (to1 - from1);
}

export class StringProgressPart extends StringModule {
  constructor(context: StringContext) {
    super(context);
    this.htmlKey = "progress-part";
    this.attributesToMap = [
      ...this.attributesToMap,
      { key: "part-of", type: "string", fallback: "" },
    ];
  }

  onObjectConnected(object: StringObject): void {
    let partOfId = object.getProperty("part-of");
    let partOfData = parsePartOf(partOfId as string);
    if (partOfData) {
      object.setProperty("part-of-id", partOfData.id);
      object.setProperty("start", partOfData.start);
      object.setProperty("end", partOfData.end);
      let progressEvent = (progress: number) => {
        if (partOfData) {
          const sliceProgress = remap(progress, partOfData?.start, partOfData?.end, 0, 1);
          const clampedProgress = Math.max(0, Math.min(1, sliceProgress));
          object.htmlElement.style.setProperty("--progress-slice", clampedProgress.toString());
          this.events.emit(`object:progress-slice:${object.id}`, clampedProgress);
        }
      };
      object.setProperty("progress-event", progressEvent);
      this.events.on(`object:progress:${partOfData.id}`, progressEvent);
    }
  }

  onObjectDisconnected(object: StringObject): void {
    let partOfId = object.getProperty("part-of-id");
    if (partOfId) {
      this.events.off(`object:progress:${partOfId}`, object.getProperty<any>("progress-event"));
    }
  }
}
